const algoliasearch = require('algoliasearch/lite');
const instantsearch = require('instantsearch.js').default;

/*
 * Import our config and widgets
 * Note: ttecSolutionsTypes, ttecSolutionsCategories, ttecSolutionsTechnology are all
 * exported from TTECSolutionsSelectMenus.js
 */
import {
  ttecSolutionsConfigure,
  ttecSolutionsSearchBox,
  ttecSolutionsSearchResults,
  ttecSolutionsTypes,
  ttecSolutionsIndustries,
  ttecSolutionsTechnology,
  ttecSolutionsClearRefinements,
  ttecSolutionsCurrentRefinements
} from '../widgets/algolia/ttec-solutions'

import { elementsConfig } from '../widgets/algolia/config/indices'
import { elementsRouting } from "../widgets/algolia/ttec-solutions/routing";

/*
 * Import shared helpers
 */
import { handleToggleVisibility } from '../helpers/search'

export default class AlgoliaTTECSolutionsSearch {
  constructor(el) {
    this.el = el;
    this.setVars();
    this.init();
  }

  setVars() {
    this.appId = elementsConfig.appId;
    this.apiKey = elementsConfig.apiKey;
    this.index = elementsConfig.indexName;
    this.env = elementsConfig.env;
  }

  init() {
    this.searchClient();
  }

  searchClient() {
    // IE support for Object.entries
    if (!Object.entries) {
      Object.entries = function( obj ){
        let ownProps = Object.keys( obj ),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
        while (i--)
          resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
      };
    }

    // start client
    const analytics = this.env === "production"; // only push analytics in production
    const algoliaClient = algoliasearch(this.appId,this.apiKey);


    // build search
    const search = instantsearch({
      indexName: this.index,
      analytics: analytics,
      routing: elementsRouting,
      searchClient: algoliaClient,
      searchFunction(helper) {
        const hideIfNoFilters = document.querySelectorAll('[data-ttecsolutions-hide-no-filter]')
        const hideIfFilter = document.querySelectorAll('[data-ttecsolutions-hide-if-filter]');
        const activeRefinements = helper.state.hierarchicalFacetsRefinements
        let hasRefinements = false;
        // figure out if any of the available facets have a refinement applied
        // if so, set var to true
        for (const [key, value] of Object.entries(activeRefinements)) {
          const array = value.length;
          if (value.length > 0) {
            hasRefinements = true;
          }
        }

        if(!hasRefinements && helper.state.query === '') {
          handleToggleVisibility(hideIfNoFilters, 'hide');
          handleToggleVisibility(hideIfFilter, 'show');
        } else {
          handleToggleVisibility(hideIfNoFilters, 'show');
          handleToggleVisibility(hideIfFilter, 'hide');
        }

        helper.search()
      }
    })


    /*
     * Add our widgets that are imported
     * from js/widgets/algolia/elements/index.js
     *
     * @DEV: Routing includes Types, Categories (Industries), Technology widgets.
     * If updates to the name or existence of these widgets are made, they must
     * be reflected in the routing file as well.
     */
    search.addWidgets([
      ttecSolutionsConfigure,
      ttecSolutionsSearchBox,
      ttecSolutionsSearchResults,
      ttecSolutionsTypes,
      ttecSolutionsIndustries,
      ttecSolutionsTechnology,
      ttecSolutionsClearRefinements,
      ttecSolutionsCurrentRefinements
    ]);


    search.start();
  }

}
